module.exports = __webpack_public_path__ + "static/img/2-2-5.3fa70c36.jpg";